import { defineMessages, type MessageDescriptor } from 'react-intl';

export const tableOfContentsButtonMessages: { buttonLabel: MessageDescriptor } = defineMessages({
	buttonLabel: {
		id: 'floating-table-of-contents-common.button-label',
		defaultMessage: 'Table of contents',
		description: 'Label for the button that opens the page table of contents',
	},
});
